module.exports = __webpack_public_path__ + "1f05cdefdd770882a875b0f178dc24a3.MP3";